"use client"

import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogTitle, DialogTrigger } from "../ui/dialog";
import { useState } from "react";
import { deploymentAvailaility } from "@/services/deployment.service";
import { z } from "zod";
import { DeletionStatus } from "@/constants/status";
import { FtpSchema } from "@/schemas/ftp.schema";
import { deleteConnection } from "@/services/ftpConnections.service";
import { Trash2 } from "lucide-react";

interface Props {
    connection: z.infer<typeof FtpSchema>,
    updateData: () => void
}

export default function FtpDeleteModal(props: Props) {
    const [open, setOpen] = useState(false)
    const [deletionStatus, setDeletionStatus] = useState(DeletionStatus.standBy);
    const [failedMessage, setFailedMessage] = useState("");

    async function DeleteConnection(){
        setDeletionStatus(DeletionStatus.onGoing);

        const authCheck = await deploymentAvailaility();
        if(authCheck === false){
            console.log("Auth Failed");
            setDeletionStatus(DeletionStatus.notAuthroized);
            return;
        }

        const formData = new FormData();
        formData.append('id', props.connection.ID);

        const status = await deleteConnection(formData);
        if(status != "Connection deleted"){
            console.log(status);
            setFailedMessage("Connection deleted failed. Check console.log for more information.<br>Otherwise, here: ".concat(status));
            setDeletionStatus(DeletionStatus.failed);
            return;
        }

        handleSuccess();
        return;
    }

    const handleSuccess = () => {
        setDeletionStatus(DeletionStatus.completed);
        setTimeout(() => {
            props.updateData();
            setDeletionStatus(DeletionStatus.standBy);
            setOpen(false);
        }, 3000);
    }

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
                <Button className="cursor-pointer"><Trash2 /></Button>
            </DialogTrigger>
            <DialogContent className="max-w-sm">
                <DialogTitle>Delete FTP Connection</DialogTitle>
                <DialogDescription> 
                </DialogDescription>
                <div>
                    {(deletionStatus === DeletionStatus.standBy ||
                        deletionStatus === DeletionStatus.notAuthroized) && (
                        <div>
                            <div className="grid grid-cols-4 gap-4">
                                <div className="col-start-1 col-end-4 rounded-md border-black">
                                    <h2>You sure you want to delete this connection?: {props.connection.Name}</h2>
                                </div>
                            </div>
                            <div className="col-start-1 col-end-7">
                                {deletionStatus == DeletionStatus.notAuthroized && (
                                    <h1 className="w-full text-xl font-bold text-black dark:text-white mb-2 py-1 px-2 rounded-md bg-red-500">
                                        Authorization to deploy failed
                                    </h1>
                                )}
                                <Button
                                    className="w-full mt-4 cursor-pointer"
                                    type="submit"
                                    onClick={DeleteConnection}
                                >
                                    Delete Connection
                                </Button>
                            </div>
                        </div>
                    )}
                </div>
                <DialogFooter>
                    <div className="grid grid-cols-6 gap-4">
                        <div className="col-start-1 col-end-7 rounded-md border-black">
                            {deletionStatus == DeletionStatus.onGoing && (
                                <div className="flex flex-col w-full max-w-2xl  gap-y-4">
                                    <p>Deleting Entry...</p>
                                </div>
                            )}
                            {deletionStatus == DeletionStatus.completed && (
                                <div className="flex flex-col w-full max-w-2xl  gap-y-4">
                                    <p>Entry Deleted! Will refresh this page momentarily</p>
                                </div>
                            )}
                            {deletionStatus == DeletionStatus.failed && (
                                <div className="flex flex-col w-full max-w-2xl  gap-y-4">
                                    <p>{failedMessage}</p>
                                </div>
                            )}
                        </div>
                    </div>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}